import { BaseElement } from 'base';

class DesignGuideCounter extends BaseElement {
  onConnect() {
    this.#bindSpecimens();
  }

  async #bindSpecimens() {
    await customElements.whenDefined('qty-counter');
    if (!this.isConnected) return;

    this.qa('qty-counter').forEach(counter =>
      counter.run(change => this.#report(change))
    );
  }

  #report({ reason, previous, value }) {
    const log = this.q('[data-counter-log]');
    if (log) log.textContent = `${reason}: ${previous} → ${value}`;
  }
}

if (!customElements.get('design-guide-counter')) {
  customElements.define('design-guide-counter', DesignGuideCounter);
}
